import { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

export const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Tech Master Event',
    },
  },
  {
    path: '/sign-in',
    name: 'Sign in',
    component: () =>
      import(/* webpackChunkName: "sign-in" */ '../views/Sign-in.vue'),
  },
  {
    path: '/sign-up',
    name: 'Sign up',
    component: () =>
      import(/* webpackChunkName: "sign-up" */ '../views/Sign-up.vue'),
  },
  {
    path: '/sign-up-success',
    name: 'Sign up success',
    component: () =>
      import(
        /* webpackChunkName: "sign-up-success" */ '../views/Sign-up-success.vue'
      ),
  },
  {
    path: '/thank_you_for_subscribing',
    name: 'Thank you for subscribing',
    component: () =>
      import(
        /* webpackChunkName: "thank-you-for-subscribing" */ '../views/ThankYouForSubscribing.vue'
      ),
  },
  {
    path: '/reset-password',
    name: 'Reset password',
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue'
      ),
  },
  {
    path: '/setup-new-password/:token',
    name: 'Setup new password',
    component: () =>
      import(
        /* webpackChunkName: "setup-new-password" */ '../views/SetupNewPassword.vue'
      ),
  },
  {
    path: '/project/new',
    name: 'ProjectNew',
    component: () =>
      import(/* webpackChunkName: "project-new" */ '../views/ProjectNew.vue'),
  },
  {
    path: '/project/edit/:slug',
    name: 'ProjectEdit',
    component: () =>
      import(/* webpackChunkName: "project-edit" */ '../views/ProjectEdit.vue'),
    props: true,
  },
  {
    path: '/project/:slug',
    name: 'Project',
    component: () =>
      import(/* webpackChunkName: "project" */ '../views/Project.vue'),
    props: true,
  },
  {
    path: '/projects/:category?/:filter?/:contest?/:sort?',
    name: 'Projects',
    component: () =>
      import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
    props: true,
  },
  {
    path: '/thank-you-for-sharing-your-project/:projectSlug?',
    name: 'Thank you for sharing your project!',
    component: () =>
      import(
        /* webpackChunkName: "thank-you-for-sharing-your-project" */ '../views/ThankYouForSharingYourProject.vue'
      ),
    props: true,
  },
  {
    path: '/contests/:filter?',
    name: 'Contests',
    component: () =>
      import(/* webpackChunkName: "contests" */ '../views/Contests.vue'),
    props: true,
  },
  {
    path: '/contest/:slug',
    name: 'Contest',
    component: () =>
      import(/* webpackChunkName: "contest" */ '../views/Contest.vue'),
    props: true,
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue'),
  },
  {
    path: '/:category(news|learn)/:slug',
    name: 'Article',
    component: () =>
      import(/* webpackChunkName: "news-article" */ '../views/Article.vue'),
    props: true,
  },
  {
    path: '/learn',
    name: 'Learn',
    component: () =>
      import(/* webpackChunkName: "learn" */ '../views/Learn.vue'),
  },
  {
    path: '/article/:slug',
    name: 'Article',
    component: () =>
      import(/* webpackChunkName: "article" */ '../views/Article.vue'),
    props: true,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/about-us',
    name: 'About us',
    component: () =>
      import(
        /* webpackChunkName: "about-us" */ '../views/AboutUs.vue'
      ),
    props: {
      slug: 'about-us',
    },
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms and Conditions',
    component: () =>
      import(
        /* webpackChunkName: "terms-and-conditions" */ '../views/TermsAndConditions.vue'
      ),
    props: {
      slug: 'terms-and-conditions',
    },
  },
  {
    path: '/privacy-policy',
    name: 'Privacy policy',
    component: () =>
      import(
        /* webpackChunkName: "Privacy policy" */ '../views/PrivacyPolicy.vue'
      ),
    props: {
      slug: 'privacy-policy',
    },
  },
  {
    path: '/introduction',
    name: 'Intruduction',
    component: () =>
      import(
        /* webpackChunkName: "introduction" */ '../views/Introduction.vue'
      ),
  },
  {
    path: '/404',
    name: '404 Page',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
  {
    path: '/:nickname',
    name: 'User profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
  },
  {
    path: '*',
    name: 'Generic 404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
]
